import React from "react";
import "./Footer.scss";

export default function Footer() {
  return (
    <footer className="footer-div">
      <div className="footer-inner">
        <span>SYAFIQAH HISHAM</span>
        <span>SOFTWARE ENGINEER · 2026</span>
        <span>BUILT WITH REACT</span>
      </div>
    </footer>
  );
}
